:host div#SSPBCatalogSubscriptionPalette {
    width: 98%;
    margin-left: 18px;
    margin-right: 18px;
    padding-bottom: 20px;
}

.ClearBoth {
    clear: both;
    height: 0px;
    line-height: 0px;
}

:host div#SSPBCatalogSubscriptionPalette ion-grid {
    padding: 0px;
}

:host div#SSPBCatalogSubscriptionPaletteh2 {
    max-width: 800px;
    padding-left: 20px;
    font-size: 1.0em;
    margin: 0px;
    margin-right: 18px;
    font-weight: 100;
    font-style: italic;
}

:host div#SSPBCatalogSubscriptionPalette ion-button {
    margin-top: 12px;
}
